<div class="credentials-details-container" *ngIf="platformControl.value && authMethodControl.value">
    <div *ngFor="let credential of credentialsDetails" class="detail-keyvalue">
        <app-detail-keyvalue
            [input]="credential"
            [placeholder]="!isInAddMode && !authMethodHadChanged && credential.isSensitive ? MOCK_SECRET_TEXT : ''">
        </app-detail-keyvalue>
    </div>
</div>

<div class="oauth-method" *ngIf="authMethodControl.value === AuthenticationMethods.oauthAuthorizationCode">
    <img
        src="{{ svgSignInPath }}"
        class="sign-in-button"
        (click)="signInUsingOauth()"
        [ngClass]="{
            'sign-in-button-disabled':
                (this.platformControl.value === 'service_now' &&
                    (this.credentialsFormGroup.controls['service-now-instance-url'].valid === false ||
                        this.credentialsFormGroup.controls['client-id'].valid === false)) ||
                userTryingToSignInUsingOauth ||
                userSignedInUsingOauth,
            'sign-in-button-required': formSubmitAttempt && !userSignedInUsingOauth && shouldUpdateCredentials,
        }" />
    <img *ngIf="userSignedInUsingOauth" class="successful-sign-in-v" src="assets/images/common/check.svg" />
</div>
